<template>
  <tabs parent="utilities" :key="permissionGod">
    <tab v-if="permissionGod" id="commands" :name="translate('utilities.commands.title')" :href="url + '/commands'">
      <Commands />
    </tab>
    <tab v-if="permissionGod" id="history" :name="translate('utilities.history.title')" :href="url + '/history'">
      <History />
    </tab>
    <tab id="tools" :name="translate('utilities.many')" :href="url + '/tools'">
      <Tools />
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Commands from './Tabs/Commands/Index.vue'
import History from './Tabs/History/Index.vue'
import Tools from './Tabs/Tools/Index.vue'

export default {
  name: 'Utilities',
  components: {Tabs, Tab, Commands, History, Tools},
  computed: {
    url () { return '/utilities' },
    permissionGod () { return this.$store.getters.getPermissions.permissionGod === true }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (!this.permissionGod && ['commands', 'history'].includes(this.$route.params.utilities_section)) {
          this.$router.replace('/utilities/tools')
        }
      }
    }
  }
}
</script>
